import { jsx as _jsx } from "react/jsx-runtime";
import { NavigationRoutes } from '../../../../../modules/Header/constants/navigationRoutes';
import { MobileLinksList } from './MobileLinksList';
const LIMITED_EDITIONS_LINKS = [
    {
        name: 'Limited & Ultra Limited Edition',
        url: NavigationRoutes.LIMITED_EDITION,
    },
    {
        name: 'Lumino',
        url: NavigationRoutes.LUMINO,
    },
];
export const LimitedDisplatesSubNavigation = () => {
    return _jsx(MobileLinksList, { links: LIMITED_EDITIONS_LINKS }, void 0);
};
//# sourceMappingURL=LimitedDisplatesSubNavigation.js.map